import React from "react";
import { useTranslation } from "react-i18next";
import {
  CircularProgressbarWithChildren,
  buildStyles,
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import hexToRgba from "hex-to-rgba";

const ViewsHoursCard = ({ watchingPercentage }) => {
  const { t } = useTranslation(["common"]);
  const percentage = watchingPercentage ?? 0;
  const progressColor = "#01C299";
  const progressColorRgb = "1, 194, 153";

  return (
    <div className="card-style views-hours-card">
      <div className="d-flex flex-wrap align-center">
        <h1 className="mb-0 font_20 font-extrabold mb-4">
          {t("watchingHoursPercentage")}
        </h1>
      </div>

      <div className="d-flex justify-content-center align-items-center views-hours-card__chart-wrap">
        <div className="views-hours-card__chart">
          <CircularProgressbarWithChildren
            value={percentage}
            strokeWidth={12}
            styles={buildStyles({
              strokeLinecap: "round",
              pathTransitionDuration: 0.5,
              pathColor: progressColor,
              textColor: progressColor,
              trailColor: hexToRgba(progressColor, 0.15),
            })}
          >
            <div className="text-center">
              <strong
                className="font_36 font-extrabold"
                style={{ color: progressColor }}
              >
                {percentage}%
              </strong>
            </div>
          </CircularProgressbarWithChildren>
        </div>
      </div>
    </div>
  );
};

export default ViewsHoursCard;
